<template>
    <loader v-if="loading" />
    <v-row v-else>
        <v-col>
            <v-card>
                <v-card-text>
                    <v-treeview
                        :active.sync="selectedTeam"
                        item-key="uniqueId"
                        open-all
                        activatable
                        return-object
                        :items="orgTree"
                    >
                        <template v-slot:append="{ item }">
                            <v-icon v-if="item.type === 'tele'" color="primary">
                                fa-headset
                            </v-icon>
                            <v-icon v-else-if="item.type === 'booking'" color="green">
                                fa-calendar-alt
                            </v-icon>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card v-if="selectedTeam[0]">
                <v-card-title>{{ selectedTeam[0].name }}</v-card-title>
                <v-divider />
                <v-card-text>
                    <v-radio-group v-model="selectedTeam[0].type">
                        <v-radio value="tele">
                            <template v-slot:label>
                                <div class="d-flex justify-space-between align-center" style="width: 100%">
                                    Tele
                                    <v-icon :color="selectedTeam[0].type === 'tele' ? 'primary' : undefined">
                                        fa-headset
                                    </v-icon>
                                </div>
                            </template>
                        </v-radio>
                        <v-radio value="booking">
                            <template v-slot:label>
                                <div class="d-flex justify-space-between align-center" style="width: 100%">
                                    Mødebook
                                    <v-icon :color="selectedTeam[0].type === 'booking' ? 'green' : undefined">
                                        fa-calendar-alt
                                    </v-icon>
                                </div>
                            </template>
                        </v-radio>
                    </v-radio-group>
                    <v-divider v-if="selectedTeam[0].type === 'tele'"></v-divider>
                    <v-radio-group v-model="selectedTeam[0].department" v-if="selectedTeam[0].type === 'tele'">
                        <v-radio value="tryg" label="Tryg" />
                        <v-radio value="alka" label="Alka" />
                    </v-radio-group>
                    <v-divider v-if="selectedTeam[0].type === 'tele'"></v-divider>
                    <v-checkbox v-model="selectedTeam[0].efficiencyRequirement" label="Effektivitetskrav" v-if="selectedTeam[0].type === 'tele'"></v-checkbox>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-btn :loading="submitting" text color="green" @click="updateTeamSetting">Gem ændringer</v-btn>
                    <v-btn :loading="submitting" v-if="selectedTeam[0].type || selectedTeam[0].department" text color="red" @click="deleteTeamSetting">Afbrød synkronisering</v-btn>
                </v-card-actions>
            </v-card>
            <v-card v-else>
                <v-card-text>Vælg et team til venstre</v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data () {
        return {
            loading: true,
            submitting: false,
            orgTree: null,
            selectedTeam: [],
            types: [ 'tele', 'booking' ]
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('controlpanel/configuration')
            this.orgTree = response.data.orgTree
            this.loading = false
        },
        async updateTeamSetting () {
            this.submitting = true
            const team = this.selectedTeam[0]
            try {
                await this.$http().patch('controlpanel/configuration', {
                    teamUniqueId: team.uniqueId,
                    type: team.type,
                    department: team.department,
                    efficiencyRequirement: team.efficiencyRequirement
                })
            } catch (e) {
                console.log(e)
            }
            this.submitting = false
        },
        async deleteTeamSetting () {
            this.submitting = true
            const team = this.selectedTeam[0]
            try {
                await this.$http().delete(`controlpanel/configuration/${team.settingsId}`)
                team.type = null
                team.department = null
                team.efficiencyRequirement = null
            } catch (e) {
                console.log(e)
            }
            this.submitting = false
        }
    },
    created () {
        this.getData()
    }
}
</script>

<style lang="scss">
.v-treeview-node__append {
    text-align: center;
}
</style>